export const DEFAULT_PEOPLE_LABELS = {
  singular: 'Nominee',
  plural: 'Nominees',
  infoHeading: "Nominee's Information",
  addButton: 'Add Nominee',
  fullName: 'Name',
  designation: 'Designation',
  email: 'Email',
  phone: 'Mobile Number',
};

/** Merge saved people labels with defaults. */
export function resolvePeopleLabels(settings) {
  const raw = settings?.people?.labels && typeof settings.people.labels === 'object'
    ? settings.people.labels
    : {};
  const pick = (key, fallback) => {
    const v = String(raw[key] ?? '').trim();
    return v || fallback;
  };
  return {
    singular: pick('singular', DEFAULT_PEOPLE_LABELS.singular),
    plural: pick('plural', DEFAULT_PEOPLE_LABELS.plural),
    infoHeading: pick('infoHeading', DEFAULT_PEOPLE_LABELS.infoHeading),
    addButton: pick('addButton', DEFAULT_PEOPLE_LABELS.addButton),
    fullName: pick('fullName', DEFAULT_PEOPLE_LABELS.fullName),
    designation: pick('designation', DEFAULT_PEOPLE_LABELS.designation),
    email: pick('email', DEFAULT_PEOPLE_LABELS.email),
    phone: pick('phone', DEFAULT_PEOPLE_LABELS.phone),
  };
}

/** Lowercase singular for mid-sentence use (e.g. pricing "per applicant"). */
export function peopleSingularLower(labels) {
  const s = String(labels?.singular || DEFAULT_PEOPLE_LABELS.singular).trim();
  return s ? s.charAt(0).toLowerCase() + s.slice(1) : 'nominee';
}

/** Lowercase plural for mid-sentence use. */
export function peoplePluralLower(labels) {
  const p = String(labels?.plural || DEFAULT_PEOPLE_LABELS.plural).trim();
  return p ? p.charAt(0).toLowerCase() + p.slice(1) : 'nominees';
}

/** Heading for a person row when multiple entries exist. */
export function personRowHeading(labels, index, total) {
  if (total <= 1) return labels.infoHeading;
  return `${labels.singular} ${index + 1}`;
}
